export default __webpack_public_path__ + "static/konsekvent-bruk2-fc2e8a4955954dae4d141822e5fe5bb1.png";